import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      d="M11.23 4.4786C10.5312 3.16407 9.49033 1.96614 8.14943 1.13761C7.85247 0.954116 7.48104 0.954131 7.18409 1.13765C5.84325 1.96623 4.8024 3.1641 4.10352 4.4786"
      stroke="#B3B3B3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M7.80859 1.22656V10.3434" stroke="#B3B3B3" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M1 7.85547V8.90378C1 9.4598 1.21611 9.99299 1.60081 10.3862C1.9855 10.7793 2.50725 11.0002 3.05128 11.0002H12.2821C12.8261 11.0002 13.3478 10.7793 13.7326 10.3862C14.1172 9.99299 14.3333 9.4598 14.3333 8.90378V7.85547"
      stroke="#B3B3B3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const UpLoadImg = memo(ForwardRef);
export default UpLoadImg;
